export function timeAgo(dateString: string) {
  const now = new Date();

  const normalized = /Z|[+-]\d{2}:\d{2}$/.test(dateString) ? dateString : dateString + '+02:00';

  const past = new Date(normalized);
  const seconds = Math.floor((+now - +past) / 1000);

  const intervals: [string, number][] = [
    ['year', 31536000],
    ['month', 2592000],
    ['day', 86400],
    ['hour', 3600],
    ['minute', 60],
  ];

  for (const [unit, value] of intervals) {
    const count = Math.floor(seconds / value);
    if (count >= 1) {
      return `${count} ${unit}${count > 1 ? 's' : ''} ago`;
    }
  }

  return 'just now';
}
